import {Component, Inject, inject, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {AppointmentType, Appointment} from '@xmedical/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {AppointmentNotificationLogComponent} from '../appointment-notification-log/appointment-notification-log.component';
import {AppointmentEditFormComponent} from '../appointment-edit-form/appointment-edit-form.component';
import {CALENDAR_DATA_PROVIDER} from '../../tokens/calendar.tokens';

export interface EditAppointmentDialogData {
  appointmentTypes: AppointmentType[];
  appointment: Appointment;
}

@Component({
  selector: 'app-edit-appointment',
  templateUrl: './edit-appointment.component.html',
  styleUrls: ['./edit-appointment.component.scss'],
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    AppointmentEditFormComponent,
  ]
})
export class EditAppointmentComponent {
  @ViewChild(AppointmentEditFormComponent) editForm: AppointmentEditFormComponent;

  private dataProvider = inject(CALENDAR_DATA_PROVIDER);

  get isSaving(): boolean {
    return this.editForm?.saving ?? false;
  }

  /** Only show the log where the provider can fetch it (practice-scoped apps) and the
   *  appointment is saved; the organisation-portal omits loadAppointmentNotifications. */
  get canViewNotificationLog(): boolean {
    return !!this.data.appointment.id && typeof this.dataProvider.loadAppointmentNotifications === 'function';
  }

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<EditAppointmentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditAppointmentDialogData,
  ) {}

  onSaved(appointment: Appointment): void {
    this.dialogRef.close(appointment);
  }

  close(): void {
    this.dialogRef.close();
  }

  triggerSave(): void {
    this.editForm.save();
  }

  viewNotifications(): void {
    this.dialog.open(AppointmentNotificationLogComponent, {
      width: '800px',
      data: {appointmentId: this.data.appointment.id}
    });
  }
}
